export default {
  maxHistory: 3,
  matches: [],
  filters: {
    changesOnly: false,
    companyId: 0
  },
  sort: {
    total: null,
    handicap: null
  }
};
